/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useTimer from 'shared/hooks/use-timer';
import size from 'modules/board-master/domain/constants/size';
import useParsePopup from 'modules/board-master/ui/hooks/use-parse-popup';
import useParseSupabase from 'modules/board-master/ui/hooks/use-parse-supabase';
import useTmBoard from 'modules/board-master/ui/hooks/use-tm-board';
import Desktop from './desktop/desktop';
import Mobile from './mobile/mobile';
import Tablet from './tablet/tablet';

function BoardPage() {
  useParsePopup();
  useParseSupabase();

  const { timer, teams, period } = useTmBoard();
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const id = useParams()?.id;

  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const orientation = window.screen.orientation.type.includes('portrait') ? 'portrait' : 'landscape';
  const isMobileInPortrait = orientation === 'portrait' && window.innerWidth < size.mobile.width;
  const isMobileInLandscape =
    orientation === 'landscape' && window.innerHeight < size.mobile.height && window.innerWidth < size.tablet;

  const { timer: time } = useTimer({ ...timer, setTime: () => {} });

  switch (true) {
    case isMobileInPortrait || isMobileInLandscape:
      return <Mobile roundTo={'floor'} time={Boolean(id) ? time : timer.time} teams={teams} period={period} />;
    case innerWidth <= size.tablet:
      return <Tablet roundTo={'floor'} time={Boolean(id) ? time : timer.time} teams={teams} period={period} />;
    default:
      return <Desktop roundTo={'floor'} time={Boolean(id) ? time : timer.time} period={period} teams={teams} />;
  }
}

export default BoardPage;
